import ReactDOM from 'react-dom/client';

import { App } from './App';
import reportWebVitals from './reportWebVitals';

import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './configuration/authConfig';
import { VortexInstance } from './core/vortex';


import './index.scss';

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
const msalInstance = new PublicClientApplication(msalConfig);
const storedVortexInstance = VortexInstance.loadFromSessionStorage();
const vortexInstance = storedVortexInstance || new VortexInstance();

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    // @ts-ignore: Object is possibly 'null'.
    msalInstance.setActiveAccount(msalInstance.getActiveAccount()[0]);
}

// Listen for sign-in event and set active account
msalInstance.addEventCallback((event) => {
  // @ts-ignore: Object is possibly 'null'.
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        // @ts-ignore: Object is possibly 'null'.
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
    }
});


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <App instance={msalInstance} vortexInstance={vortexInstance}/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
